import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LayoutRoutingModule } from './layout-routing.module';
import { SidenavComponent } from './sidenav/sidenav.component';
import { HeaderComponent } from './header/header.component';
import { WrapperComponent } from './wrapper/wrapper.component';
import { BusinessWrapperComponent } from './business-wrapper/business-wrapper.component';
import { BusinessSidenavComponent } from './business-sidenav/business-sidenav.component';
// import { MobHeaderComponent } from './mob-header/mob-header.component';
import { MobSidenavComponent } from './mob-sidenav/mob-sidenav.component';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FooterComponent } from './footer/footer.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
// import { EnquiriesComponent } from './enquiries/enquiries.component';
import { TestimonialsComponent } from './testimonials/testimonials.component';
import { ProductDetailComponent } from './product-detail/product-detail.component';
//import { ToggleSwitchComponent } from './toggle-switch/toggle-switch.component';
// import { BrandsComponent } from './brands/brands.component';
// import { ProductComponent } from './product/product.component';

import { MachineComponent } from './machine/machine.component';
import { ServiceComponent } from './service/service.component';
import { ToolsComponent } from './tools/tools.component';
import { SearchResultsComponent } from './search-results/search-results.component';
import { RawMaterialsComponent } from './raw-materials/raw-materials.component';
import { MainHomeComponent } from './main-home/main-home.component';
import { PipeModule } from '../pipe/pipe.module';
// import { BlogsComponent } from '../auth/blogs/blogs.component';

@NgModule({
    declarations: [
        SidenavComponent,
        HeaderComponent,
        WrapperComponent,
        BusinessWrapperComponent,
        BusinessSidenavComponent,
        // MobHeaderComponent,
        MobSidenavComponent,
        // EnquiriesComponent,
        FooterComponent,
        TestimonialsComponent,
        ProductDetailComponent, 
        MachineComponent,
         ServiceComponent,
        ToolsComponent,
        SearchResultsComponent,
        RawMaterialsComponent,
        MainHomeComponent,
        // BlogsComponent
        //  ToggleSwitchComponent,
    ],
    imports: [
        CommonModule,
        LayoutRoutingModule,
        MatSelectModule,
        MatFormFieldModule,
        ReactiveFormsModule,
        FormsModule,
        PipeModule,

    ],
    exports: [
        HeaderComponent, 
        TestimonialsComponent,
        FooterComponent
        // ,EnquiriesComponent

    ]
})
export class LayoutModule { }
